// src/composables/useOLLCustomSet.js
import { ref, watch } from 'vue';

export function useOLLCustomSet() {
  // Load saved custom sets from localStorage
  const customSet1 = ref(
    loadFromStorage('oll-tolearn-set1') || [
      9, 10, 15, 16, 19, 31, 35, 37, 38, 40, 46, 52, 54, 55, 56,
    ]
  );
  const customSet2 = ref(
    loadFromStorage('oll-tolearn-set2') || [
      1, 9, 10, 17, 19, 20, 28, 35, 37, 38, 41, 42, 46, 55, 56, 57,
    ]
  );

  // Track which algorithms are selected for editing
  const editingSet = ref(null);
  const tempSelection = ref([]);

  // Watch for changes and save to localStorage
  watch(
    customSet1,
    (newVal) => {
      saveToStorage('oll-tolearn-set1', newVal);
    },
    { deep: true }
  );

  watch(
    customSet2,
    (newVal) => {
      saveToStorage('oll-tolearn-set2', newVal);
    },
    { deep: true }
  );

  // Get the current custom set being used
  const getCurrentSet = (setName) => {
    if (setName === 'tolearn') return customSet1.value;
    if (setName === 'tolearn2') return customSet2.value;
    return [];
  };

  // Start editing a set
  const startEditingSet = (setName) => {
    console.log('startEditingSet called with:', setName);
    editingSet.value = setName;

    if (setName === 'tolearn') {
      tempSelection.value = [...customSet1.value];
    } else if (setName === 'tolearn2') {
      tempSelection.value = [...customSet2.value];
    }

    console.log('editingSet set to:', editingSet.value);
    console.log('tempSelection set to:', tempSelection.value);
  };

  // Toggle an algorithm in the temp selection
  const toggleAlgorithm = (algoId) => {
    console.log('toggleAlgorithm called with:', algoId);
    console.log('Current tempSelection:', tempSelection.value);

    const index = tempSelection.value.indexOf(algoId);
    if (index > -1) {
      // Remove it
      const newSelection = [...tempSelection.value];
      newSelection.splice(index, 1);
      tempSelection.value = newSelection;
      console.log('Removed. New selection:', tempSelection.value);
    } else {
      // Add it
      tempSelection.value = [...tempSelection.value, algoId];
      console.log('Added. New selection:', tempSelection.value);
    }

    if (algoId == 0) {
      tempSelection.value = [];
    } else if (algoId == 100) {
      tempSelection.value = [];
      for (let i = 1; i <= 57; i++) {
        tempSelection.value.push(i);
      }

      // tempSelection.value = [
      //   1, 9, 10, 17, 19, 20, 28, 35, 37, 38, 41, 42, 46, 55, 56, 57,
      // ];
    }
  };

  // Check if an algorithm is in temp selection
  const isInTempSelection = (algoId) => {
    return tempSelection.value.includes(algoId);
  };

  // Save the temp selection to the actual set
  const saveCustomSet = () => {
    if (editingSet.value === 'tolearn') {
      customSet1.value = [...tempSelection.value].sort((a, b) => a - b);
    } else if (editingSet.value === 'tolearn2') {
      customSet2.value = [...tempSelection.value].sort((a, b) => a - b);
    }
    cancelEditing();
  };

  // Cancel editing
  const cancelEditing = () => {
    editingSet.value = null;
    tempSelection.value = [];
  };

  // Reset a set to default
  const resetToDefault = (setName) => {
    if (setName === 'tolearn') {
      customSet1.value = [
        9, 10, 15, 16, 19, 31, 35, 37, 38, 40, 46, 52, 54, 55, 56,
      ];
    } else if (setName === 'tolearn2') {
      customSet2.value = [
        1, 9, 10, 17, 19, 20, 28, 35, 37, 38, 41, 42, 46, 55, 56, 57,
      ];
    }
  };

  return {
    customSet1,
    customSet2,
    editingSet,
    tempSelection,
    getCurrentSet,
    startEditingSet,
    toggleAlgorithm,
    isInTempSelection,
    saveCustomSet,
    cancelEditing,
    resetToDefault,
  };
}

// Helper functions for localStorage
function loadFromStorage(key) {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error('Error loading from localStorage:', e);
    return null;
  }
}

function saveToStorage(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error('Error saving to localStorage:', e);
  }
}
